export default {
  // This component uses dynamic labels from props (channelName)
  // No static translatable strings
}
